import {identity} from '@packages/utilities/fp/utils';
import {type Json, matchJson} from '@packages/utilities/json';

const select = <t>(from: t, prop: Json) => ({
  type: 'Select',
  val: {from, prop},
});

export const migrateReferenceToVariableAndSelect: (arg1: Json) => Json =
  matchJson({
    Null: identity,
    Boolean: identity,
    Number: identity,
    String: identity,
    Array: identity,
    Object: (obj) => {
      const {type, ref} = obj;
      if (!type || !ref || type !== 'Reference') return obj;
      const returnOriginal = (
        _: null | number | string | boolean | Array<Json>
      ) => obj;

      return matchJson({
        Null: returnOriginal,
        Boolean: returnOriginal,
        Number: returnOriginal,
        String: returnOriginal,
        Array: returnOriginal,
        Object: ({id, path}) => {
          if (!id || !path) return obj;
          if (!Array.isArray(path)) return obj;

          return path.reduce(select, {type: 'Variable', val: id});
        },
      })(ref);
    },
  });
